import styled from 'styled-components';
import MuiModal from '@mui/material/Modal';

export const Modal = styled(MuiModal)`
  &.MuiModal-root {
    padding: 0;
    overflow-y: auto;

    &.limit-modal {
      z-index: 3000;
    }
  }

  .modal-center {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
`;
